import React from "react";
import { Link } from "react-router-dom";

export default function Menu() {
  return (
    <div className="admin-sidebar">
      <img
        className="admin-sidebar-logo"
        src="https://tuquejasuma.com/media/images/entity103476_square.png"
        alt=""
      />

      {/* <Link onClick={() => {
            window.scrollTo(0, 0)
          }} to={"/adm"} className="admin-sidebar-link">
      <img width="18" height="18" src="https://img.icons8.com/material-sharp/48/ffffff/dashboard-layout.png" alt="dashboard-layout"/>
        <p className="admin-sidebar-link-text">Dashboard</p>
      </Link> */}

      <Link onClick={() => {
            window.scrollTo(0, 0)
          }} to={"/adm"} className="admin-sidebar-link">
      <img width="18" height="18" src="https://img.icons8.com/windows/32/ffffff/block-chain.png" alt="block-chain"/>
        <p className="admin-sidebar-link-text">Artículos</p>
      </Link>

      <Link onClick={() => {
            window.scrollTo(0, 0)
          }} to={"/adm/create"} className="admin-sidebar-link">
      <img width="18" height="18" src="https://img.icons8.com/material-sharp/48/ffffff/add.png" alt="add"/>
        <p className="admin-sidebar-link-text">Nuevo artículo</p>
      </Link>

      {/* <Link to={"/adm/drafts"} className="admin-sidebar-link">
      <img width="18" height="18" src="https://img.icons8.com/ios/50/ffffff/edit-file.png" alt="edit-file"/>
        <p className="admin-sidebar-link-text">
        Borradores
        </p>
      </Link> */}

      <Link onClick={() => {
            window.scrollTo(0, 0)
          }} to={"/adm/gallery"} className="admin-sidebar-link">
      <img width="18" height="18" src="https://img.icons8.com/external-regular-kawalan-studio/48/ffffff/external-images-multimedia-regular-kawalan-studio.png" alt="external-images-multimedia-regular-kawalan-studio"/>
        <p className="admin-sidebar-link-text">
        Galería
        </p>
      </Link>
      <Link onClick={() => {
            window.scrollTo(0, 0)
          }} to={"/adm/banners"} className="admin-sidebar-link">
      <img width="18" height="18" src="https://img.icons8.com/ios-glyphs/30/ffffff/block--v1.png" alt="external-images-multimedia-regular-kawalan-studio"/>
        <p className="admin-sidebar-link-text">
        Banners
        </p>
      </Link>
    </div>
  );
}
